/* eslint-disable react/no-multi-comp */
import React, { Component } from "react"
import {  Row, Col,OverlayTrigger,Tooltip } from 'react-bootstrap'
import { PropTypes } from "prop-types"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from "react-router-dom"
import { getUserRole } from "../../redux/actions/action_user"
import ContentWrapper from '../../components/layout/ContentWrapper'
import { tooltips } from '../../utils/constants/tooltip'
import { URL } from '../../config'
import userManager from '../../userManager'
import { getRequest } from '../../utils/functions/httpRequest'

const tooltip = (message) =>  (
	<Tooltip id="tooltip">
		<strong> {message} </strong>
	</Tooltip>
)
   
 class Dashboard extends Component {

	constructor(props)
	{
		super(props)
		this.state = {
			userRequests:0,
			eventsThisWeek:0,
			orphanedEvents:0,
			roleChecked:false
		}
		this.getRecentActivities = this.getRecentActivities.bind(this)
		this.applyPermission = this.applyPermission.bind(this)
	}  

	componentDidMount()
	{
		const { oidc }    = this.props
		const _this = this      
	
		if (oidc.user === null)
		{
			userManager.signinRedirect().then(function() {
				_this.applyPermission()
			})
		}
		else
		{
			this.getRecentActivities()
		}
	}

	getRecentActivities() {
		const statsendpoint = '/recentactivity'
		const token = this.props.oidc.user.access_token
		const  eventURL =  `${URL.event}${statsendpoint}`
		const _this = this
		getRequest(eventURL,'json',token).then(function(response){
			const { userRequests, eventsThisWeek, orphanedEvents } = response.data
			_this.setState({
				userRequests,
				eventsThisWeek,
				orphanedEvents 
			})
		})
	}

	applyPermission()
	{
		const { user , oidc } = this.props
		const { roleChecked  } = user

		if(oidc.user !== null) {
			if((roleChecked === false) && (this.state.roleChecked === false))
			{
				this.props.dispatch(getUserRole()) 
				this.setState({ 
				roleChecked:true
				}) 
			} 
		}
	}

	render() {    
		const { userRequests, eventsThisWeek, orphanedEvents } = this.state
		const { roleName } = this.props.user
		const metricAlignment = { paddingLeft:'30px' }    
		const { oidc } = this.props
		const uservalidated = oidc.user != null

		const  isAdministrator = (roleName === 'Administrator')

		return (
				uservalidated && (<ContentWrapper>
				<div className="content-heading">Dashboard</div>
					<Row>
						<Col sm={6} >
							<h5>Click on any of the metrics for more detailed information.</h5>
							<p />
						</Col>
					</Row>    
					<Row style={{ marginTop:'20px' }}>
					<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.eventsthisweek)}>      
						<Col  lgOffset={1} lg={ 3 } sm={ 6 }>
							{ /* START widget */ }
							<div className="panel widget bg-purple"  style={{ cursor: 'pointer' }}>
								<Link to="event"  style={{ color: 'white' }}>
									<Row className="row-table">
										<Col xs={ 3 }  className="text-left bg-purple-dark pv-sm" style={{ paddingLeft:'25px' }}>
											<em className="fa fa-calendar fa-2x" />
										</Col>
										<Col xs={ 9 } className="pv-lg">
											<div className="h5 mt0" style={metricAlignment}>{eventsThisWeek}</div>
											<div> Events this week</div>
										</Col>
									</Row>
									</Link>
							</div>
						</Col>
					</OverlayTrigger>
					{
						isAdministrator === true && (<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.orphanedevents)}>         
						<Col lg={ 3 } md={ 6 } sm={ 12 }>
							{ /* START widget */ }
							<div className="panel widget bg-green"  style={{ cursor: 'pointer' }}>
							<Link to="/orphanedEvents"  style={{ color: 'white' }}>
								<Row className="row-table">
									<Col xs={ 3 } lg={3} className="text-left bg-green-dark pv-sm" style={{ paddingLeft:'20px' }}>
											<em className="fa fa-clock-o fa-3x" />
									</Col>
									<Col xs={ 9 } lg={9} className="pv-lg">
											<div className="h5 mt0">{orphanedEvents}</div>
											<div>Orphaned Events</div>
									</Col>
								</Row>
								</Link>
							</div>
						</Col>
							</OverlayTrigger>)
					}  
					{
						isAdministrator === true && (<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.userrequests)}>        
						<Col lg={ 3 } sm={ 6 }>
						<div className="panel widget"  style={{ cursor: 'pointer', backgroundColor:'#3b5998', color: 'white' }}>
						<Link to="/usermanagement"  style={{ color: 'white' }}>
							<Row className="row-table">
								<Col xs={ 3 } className="text-left pv-sm" style={{ backgroundColor:'#3b5980',paddingLeft:'25px' }}>
									<em className="fa fa-users fa-2x" />
								</Col>
								<Col xs={ 9 } className="pv-lg">
									<div className="h5 mt0" style={metricAlignment}>{userRequests}</div>
									<div>User Requests</div>
								</Col>
							</Row>
						</Link>
						</div>
						</Col>
					</OverlayTrigger>)
					}                     
				</Row>
		</ContentWrapper>)
		)
	}
}

Dashboard.propTypes = {
	dispatch: PropTypes.func,
	oidc: PropTypes.object,
	user: PropTypes.object
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		getUserRole
	},dispatch)
}

const mapStateToProps = ({  oidc, user }) => {
	return {
		oidc: { ...oidc },
		user: { ...user }
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Dashboard)

 




// WEBPACK FOOTER //
// ./src/containers/dashboard/index.js